export default class Address {
    constructor(options) {
        options = options || {};

        this.Status = options.Status || '';
        this.Address = options.Address || '';
    }
}